import { LegacyPage } from '@legacy/components/layout/LegacyPage';
import { PageSettingsWrapper } from './components/PageSettingsWrapper';

export const PageSetting = () => (
  <PageSettingsWrapper>
    <LegacyPage data-automation-id="LegacyPage" />
  </PageSettingsWrapper>
);
